<template>
  <div class="footer-wrap">
    <div class="container py-4">
      <div class="row align-items-center">
        <div class="col-xl-6 col-md-6 col-sm-12 pbelow">
          <span class="footer-copy">© {{ year }} Andrea Ierardi</span>
        </div>
        <div class="col-xl-6 col-md-6 col-sm-12">
          <div class="text-center">
            <button
              class="btn footer-btn mx-2"
              @click="open('linkedin')"
              v-tooltip.bottom="'LinkedIn'"
            >
              <i class="fab fa-linkedin"></i>
            </button>
            <button
              class="btn footer-btn mx-2"
              @click="open('github')"
              v-tooltip.bottom="'GitHub'"
            >
              <i class="fab fa-github"></i>
            </button>
            <button
              class="btn footer-btn mx-2"
              @click="open('instagram')"
              v-tooltip.bottom="'Instagram'"
            >
              <i class="fab fa-instagram"></i>
            </button>
            <button
              class="btn footer-btn mx-2"
              @click="open('twitter')"
              v-tooltip.bottom="'Twitter'"
            >
              <i class="fab fa-twitter"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import info from "../../info";

export default {
  name: "Footer",
  data() {
    return {
      year: new Date().getFullYear(),
      linkedin: info.links.linkedin,
      github: info.links.github,
      instagram: info.links.instagram,
      twitter: info.links.twitter,
    };
  },
  methods: {
    open(link) {
      switch (link) {
        case "linkedin":
          window.open(this.linkedin, "_blank");
          break;
        case "github":
          window.open(this.github, "_blank");
          break;
        case "instagram":
          window.open(this.instagram, "_blank");
          break;
        case "twitter":
          window.open(this.twitter, "_blank");
          break;
      }
    },
  },
};
</script>

<style scoped>
.footer-wrap {
  background: linear-gradient(135deg, #02aab0, #00cdac);
}

.footer-copy {
  color: rgba(255, 255, 255, 0.85);
  font-weight: 500;
  font-size: 14px;
}

.footer-btn {
  border-color: rgba(255, 255, 255, 0.6);
  color: #fff;
  border-radius: 50%;
  width: 38px;
  height: 38px;
  padding: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: all 0.25s ease;
  font-size: 15px;
}

.footer-btn:hover {
  background-color: #fff;
  border-color: #fff;
  color: #02aab0;
  transform: translateY(-2px);
}

.footer-btn:focus {
  outline: none !important;
  box-shadow: none;
}

@media screen and (max-width: 580px) {
  .pbelow {
    padding-bottom: 16px;
    text-align: center;
  }
}
</style>
